<template>
  <div class="event-push-box">
    <div class="title-box">
      <span>{{ eventName }}</span>
    </div>
    <div class="header-box-app flex-between">
      <div class="flex-1">
          <div class="num related-num">{{ handlerTime(total) }}</div>
          <div class="name related-name">相关报道</div>
      </div>
      <div class="flex-1">
        <!-- 1 上涨 2 下降 3 平衡 -->
          <div :class="'num rise-num event-rise'+isIncrease">{{ increaseTrend }}</div>
          <div class="name rise-name flex">近一小时增量
            <i v-if="isIncrease === 1" class="iconfont icon-rise rise"></i>
            <i v-if="isIncrease === 2" class="iconfont icon-down down"></i>
            <i v-if="isIncrease === 3" class="iconfont icon-fair fair"></i>
          </div>
      </div>
      <div class="flex-1">
          <div class="num sentiment-num">{{ sentimentIndex }}</div>
          <div class="name sentiment-name">情感指数</div>
      </div>
      <div class="flex-1">
          <div class="num hot-num">{{ rankTotalCount }}</div>
          <div class="name hot-name">热榜</div>
      </div>
    </div>
    <div class="important-media-echart">
      <div class="echart-box">
        <div id="important-media-app" class="pie-box">
        </div>
      </div>
      <div class="important-media-title flex">
        <div class="flex-1">{{ mediaSourceCount.centerNumber }}<span>家</span></div>
        <div class="flex-1">{{ mediaSourceCount.provinceNumber }}<span>家</span></div>
        <div class="flex-1">{{ mediaSourceCount.otherNumber + mediaSourceCount.localNumber }}<span>家</span></div>
      </div>
    </div>
    <div class="copy-all-box" @click="handlerCopyAll">
      <i class="iconfont icon-copy"></i>
      <span>复制</span>
    </div>
    <div class="detail-content">
      <div v-if="mediaCount" class="event-sum">
        <div class="titlle">事件概况<i class="iconfont icon-copy" @click="handlerCopy(1)"></i></div>
        <div class="event-title-content">关于<span>【{{ eventName }}】</span></div>
        <div class="content" v-html="mediaCount"></div>
      </div>
      <div v-if="rankInfo" class="important-media">
        <div class="titlle">热搜榜<i class="iconfont icon-copy" @click="handlerCopy(2)"></i></div>
        <div class="content" v-html="rankInfo"></div>
      </div>
      <div v-if="importantMedia" class="important-media">
        <div class="titlle">重点媒体<i class="iconfont icon-copy" @click="handlerCopy(3)"></i></div>
        <div class="content" v-html="importantMedia"></div>
      </div>
      <div v-if="netview" class="netizen-view">
        <div class="titlle">网民观点<i class="iconfont icon-copy" @click="handlerCopy(4)"></i></div>
        <div class="content" v-html="netview"></div>
      </div>
      <div class="time-box">{{ pushTime }}</div>
      </div>
      <!-- 授权 -->
    <div class="van-overlay" v-show="showOverlay">
      <div class="wrapper">
        <div class="block">
          <div class="head">安全校验</div>
          <div class="info">为保证信息安全性，请<span>授权</span>后再查看信息详情或访问原链查看信息详情</div>
          <div class="button-w">
            <!-- <div class="div1" @click="jzUrl()">访问原链接</div> -->
            <div @click="showYzmpage()">去授权</div>
          </div>
        </div>
      </div>
    </div> 
    <div class="van-overlay van-overlay1" v-show="showOverlayyz">
      <div class="tab_bar_box border_box flex_v_center flex_v_1">
        <div class="left_box">
          <i class="back_icon" @click="showOverlayyz = false;showOverlay=true"></i>
        </div>
        <div class="flex-1">手机号授权</div>
      </div>
      <div class="van-overlay-warys">
        <div class="item">
          <input type="tel" class="van-field__control"  v-model="phones" placeholder="请输入手机号"  > 
        </div> 
        <p class="error-info showError" ></p>
        <div class="item item-verification">
          <input type="" class="van-field__control"  v-model="verification" placeholder="请输入验证码"  />
          <p v-if="codeLoginIng.isCountdown" @click="getYzm">获取验证码</p>
          <p v-else>重新发送({{ codeLoginIng.countdown }})</p>
        </div>
       <p class="error-info top10" :class="phones_error ? 'showError': ''">{{phones_error}}</p>
        <div class="item-button" @click="setSubmit">
          完成
        </div>
      </div>
    </div> 
    <!-- 授权结束 -->
  </div>
</template>
<script>
import { getEventPushDetail } from '@/api/eventpush'
import {handleClipboard} from '../../../assets/js/clipboard'
import { Notify } from 'vant';
import { wxShare } from '@/helpers/eventWxconfig'
import { fetch } from "@/helpers/fetch"
import VueCookies from 'vue-cookies'
import echarts from 'echarts'
export default {
  name: 'eventpushdetail',
  components: {
  },  
  data(){
    return {
      codeLoginIng: {
        isCountdown: true,
        countTimer: '',
        countdown: 60
      },
      phones:'',
      verification:'',
      phones_error:'',
      yzm_error:'',
      showOverlay:false,
      showOverlayyz:false,
      id:'', // '01e460c5a46542fa8b914689243409e0'
      eventName: "",
      importantMedia: "",
      mediaCount: "",
      netview: "",
      pushTime:"",
      rankTotalCount: 0,
      sentimentIndex: 0,
      mediaSourceCount: {
        total: 0,
        localNumber: 0,
        otherNumber: 0,
        centerNumber: 0,
        provinceNumber: 0,
        localPercentage: 0,
        otherPercentage:0,
        centerPercentage: 0,
        provincePercentage: 0
      },
      increaseTrend: 0,
      isIncrease: 1, // 1增长，2下降，3不变
      rankInfo: '',
      total: 0,
      importantMediaCopy:'',
      mediaCountCopy: '',
      netviewCopy: '',
      rankInfoCopy: ''
    }
  },
  methods: {
    handlerChart() {
      // 重要媒体
      const importantMediaAppDatas = [{
            "name": "央级媒体",
            "value": this.mediaSourceCount.centerPercentage
        }, {
            "name": "省级媒体",
            "value": this.mediaSourceCount.provincePercentage
        }, {
            "name": "其他媒体",
            "value": this.mediaSourceCount.otherPercentage + this.mediaSourceCount.localPercentage
        }]
      const importantMediaAppDom = document.getElementById('important-media-app')
      const importantMediaAppChart = echarts.init(importantMediaAppDom);
      const importantMediaAppChartObj = {};
      importantMediaAppChartObj.data = importantMediaAppDatas;
      importantMediaAppChart.setOption(this.multiPie(importantMediaAppChartObj));
    },
    multiPie(optionsObj) {
        const { data } = optionsObj
        let layoutArr = [
          { radius: [30, 38], center: ['16.6%', '50%'], rgba: 'rgba(230,84,65,' },
          { radius: [30, 38], center: ['49.9%', '50%'], rgba: 'rgba(230,150,12,' },
          { radius: [30, 38], center: ['83.2%', '50%'], rgba: 'rgba(80,144,241,' }
        ]
        let datas = data ? data : [
            { name: '央级媒体', value: 0 },
            { name: '省级媒体', value: 0 },
            { name: '其他媒体', value: 0 }
        ]
        const series = []
        datas.map((item, index) => {
            return series.push({
                name: item.name,
                type: 'pie',
                clockWise: false,
                hoverAnimation: false,
                silent: true,
                radius: layoutArr[index] && layoutArr[index].radius,
                itemStyle: {
                    normal: {
                        label: {
                            show: false
                        },
                        labelLine: {
                            show: false
                        }
                        // shadowBlur: 6,
                        // shadowColor: `${layoutArr[index] && layoutArr[index].rgba} .5)`
                    }
                },
                center: layoutArr[index] && layoutArr[index].center,
                data: [{
                    value: 100 - item.value,
                    name: 'invisible',
                    itemStyle: {
                        normal: {
                            color: `${layoutArr[index] && layoutArr[index].rgba} .1)`
                        }
                    }
                }, {
                    value: item.value,
                    label: {
                        normal: {
                            rich: {
                                a: {
                                    color: '#222',
                                    align: 'center',
                                    fontSize: 12,
                                    lineHeight: 22
                                },
                                b: {
                                    color: '#222',
                                    align: 'center',
                                    fontWeight: 'bold',
                                    fontSize: 12,
                                    lineHeight: 22
                                }
                            },
                            formatter: (params) => {
                                let temp = ''
                                if (typeof(params.value) === 'string') {
                                    temp = '\n{b|' + params.seriesName + '}' + '\n{a|' + params.value + '}'
                                } else {
                                    temp = '{b|' + params.seriesName + '}' + '\n{a|' + parseFloat(params.percent.toFixed(2)) + '%' + '}'
                                }
                                return temp
                            },
                            position: 'center',
                            show: true,
                            textStyle: {
                                fontSize: '14',
                                fontWeight: 'normal',
                                color: '#5090F1'
                            }
                        }
                    },
                    itemStyle: {
                        normal: {
                            color: `${layoutArr[index] && layoutArr[index].rgba} 1)`
                        }
                    }
                }]
            })
        })
        return {
            series: series
        }
    },
    handlerTime(val) {
      return parseFloat(val).toLocaleString()
    },
    handlerCopyAll() {
      let content = ''
      if (this.mediaCountCopy) {
        content = content + '事件概况：\n\xa0\xa0\xa0\xa0' + this.mediaCountCopy + '\n\n'
      }
      if (this.rankInfoCopy) {
        content = content + '热搜榜：\n' + this.rankInfoCopy + '\n'
      }
      if (this.importantMediaCopy) {
        content = content + '重点媒体：\n\xa0\xa0\xa0\xa0' + this.importantMediaCopy + '\n\n'
      }
      if (this.netviewCopy) {
        content = content + '网民观点：\n' + this.netviewCopy
      }
      this.copy(content)
    },
    handlerCopy(type) {
      let content = ''
      if (type === 1) {
        content = content + '事件概况：\n\xa0\xa0\xa0\xa0' + this.mediaCountCopy
      } else if (type === 2) {
        content = content + '热搜榜：\n' + this.rankInfoCopy
      } else if (type === 3) {
        content = content + '重点媒体：\n\xa0\xa0\xa0\xa0' + this.importantMediaCopy
      } else if (type === 4) {
        content = content + '网民观点：\n' + this.netviewCopy
      }
      this.copy(content)
    },
    // 复制功能
    copy(content) {
      handleClipboard(content, event, () => {
          Notify({
            message: '复制成功',
            duration: 1000,
            color: "",
            className: "notifyNew",
            background: ''
          });
        }, () => {
          Notify({
            message: '复制失败！',
            duration: 1000,
            color: "",
            className: "notifyErr",
            background: ''
          });
        })
    },
    queryData(){
      getEventPushDetail({id:this.id}).then(res => {
        if(res.status == 200){
          let result = res.data;
          this.eventName = result.eventName || '';
          this.importantMedia = result.importantMedia || '';
          this.mediaCount = result.mediaCount || '';
          this.netview = result.netview || '';
          this.pushTime = result.pushTime || '';
          this.rankTotalCount = result.rankTotalCount || 0;
          this.sentimentIndex = result.sentimentIndex || 0;
          this.mediaSourceCount = result.mediaSourceCount || this.mediaSourceCount;
          this.increaseTrend = result.increaseTrend || 0;
          this.isIncrease = result.isIncrease || 0;
          this.rankInfo = result.rankInfo || '';
          this.total = result.total || 0;
          this.importantMediaCopy = result.importantMediaCopy || '';
          this.mediaCountCopy = result.mediaCountCopy || '';
          this.netviewCopy = result.netviewCopy || '';
          this.rankInfoCopy = result.rankInfoCopy || '';
          this.handlerChart()
          wxShare(result.eventName,'',this)
        }
      }).catch(err=>{
        console.log(err);
      });
    },
    isValidPhoneNumber(phoneNumber){
      const phoneRegex = /^1[0-9]{10}$/;
      return phoneRegex.test(phoneNumber);
    },
    getYzm(){
      this.phones_error = ''
      if(!this.phones){
        this.phones_error = '请输入手机号！'
        return false
      }
      if(!this.isValidPhoneNumber(this.phones)){
        this.phones_error = '请输入正确的手机号！'
        return false
      }
      this.getSendCode()
    },
   async getSendCode(){
     let url = '/api/usercenter/AuthorizationController/sendCode'
     let p ={
        url: url,
        method: 'get',
        params: {
          telphone:this.phones
        }
      }
     let res = await fetch(p)
     let { data } = res
    if(data.status == 1){
      this.phones_error = '验证码已发送手机，请注意查收！'
      this.setTime(this.codeLoginIng)
    }else{
      this.phones_error = data.msg
    } 
   },
   async setSubmit(){
     this.phones_error = ''
    if(!this.phones){
      this.phones_error = '请输入手机号！'
      return false
    }
    if(!this.isValidPhoneNumber(this.phones)){
      this.phones_error = '请输入正确的手机号！'
      return false
    }
    if(!this.verification){
      this.phones_error = '请输入验证码！'
      return false
    } 
    let url ='api/usercenter/AuthorizationController/checkCode'
    let p = {
      url: url,
      method: 'get',
      params:{
        telphone:this.phones,
        code:this.verification,
      }
    }
    let res = await fetch(p)
    let { data } = res
    if(data.status == 1){
      // alert('验证通过')
      this.phones_error = '验证通过'
      document.body.style.overflowY = 'auto'
      this.showOverlayyz = false
      const date = new Date()
      const minutes = 1440 * 7 
      // const minutes = 60
      date.setTime(date.getTime() + (minutes * 60 * 1000))
      VueCookies.set('AUTHORISE', 1, { expires: date, path: '/' })
      VueCookies.set('TELPHONES', this.phones, { expires: date, path: '/' })
    }else{
      this.phones_error = data.msg
    }
    console.log(res)
    this.setLog()
   },
   setLog(){
    let data = {
      token:"bG9ncHJvY2Vzcw==",
      telphone:this.phones, //手机号
      url:window.location.href,// url
      userId:'',  
      accountId:'',
      shareChannel:3, //分享渠道
      shareType:2, //分享类型 1 事件分析  2微信
      openId: this.$route.query.openid || ''
    }
    let url = '/v4/api/user/auth/log'
    let p = {
      url: url,
      method: 'post',
      istoken:true,
      data: data
    }
    fetch(p) 
   },
   setTime(obj) {
      if (!obj.countdown) {
        obj.isCountdown = true
        obj.countTimer = null
        obj.countdown = 60
        return false
      } else {
        obj.isCountdown = false
        obj.countdown--
      }
      obj.countTimer = setTimeout(() => {
        this.setTime(obj)
      }, 1000)
    },
    showYzmpage(){
      this.showOverlay = false
      this.showOverlayyz = true
    },
    jzUrl(){
      if(this.detailInfo && this.detailInfo.url){
        window.location.href =  this.detailInfo.url
      } 
    }
  },
  mounted() {
    let query = this.$route.query;
    this.id = query.id
    this.$store.state.userInfo.openid = query.openid
    this.queryData(this.id);
    let isAuthorised = query.isAuthorised || ''
    let authorizev = VueCookies.get('AUTHORISE') || ''  
    if(!authorizev && isAuthorised){ 
      //显示
      this.showOverlay = true
      document.body.style.overflowY = 'hidden'
    }
  }
}
</script>
<style scoped>
	@import './detail.css';
  @import url("../../pushwarning/detail/detail.css"); 
</style>
